<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Name"
                  v-model="way.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="way.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="way.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12 v-if="way.id">
                <v-text-field label="Created Date" type="text" v-model="createdDate" readonly></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="way.id">
                <v-text-field label="Created By" type="text" v-model="way.createdBy" readonly></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="way.id">
                <v-text-field label="Updated Date" type="text" v-model="updatedDate" readonly></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="way.id">
                <v-text-field label="Updated By" type="text" v-model="way.updatedBy" readonly></v-text-field>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn color="success" @click="showCustomerShops()">
                    Add Way Customer Shop
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text" v-if="way.wayCustomerShops.length > 0">
                  <v-flex xs2>Shop Name</v-flex>
                  <v-flex xs2>Township</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout row wrap v-for="(item, index) in way.wayCustomerShops" :key="index">
                  <v-flex xs2>
                    <v-text-field
                      placeholder="Choose Shop"
                      v-model="item.customerShopName"
                      :rules="rules.codeRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field v-model="item.township" label="Choose Township" :readonly="true"></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn icon @click="removeCustomerShop(index, item.id)">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    type="submit"
                    :disabled="btnDisabled"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- Product list dialog -->
    <v-dialog v-model="showCustomerShopListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Customer Shop Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Customer Shop Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="customerShopType"
                label="Choose Type ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.type"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="township"
                label="TownShip"
                type="text"
                v-model="queryParams.township"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer Shop List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              v-model="selectedCustomerShop"
              :headers="headers"
              :items="customerShopList"
              select-all
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th>
                    <v-checkbox
                      primary
                      hide-details
                      @click.native="toggleAll"
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                    ></v-checkbox>
                  </th>
                  <th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    :input-value="props.selected"
                    :value="props.item"
                    v-model="selectedCustomerShop"
                  ></v-checkbox>
                </td>
                <td
                  @click="setWayCustomerShop(props.item, selectedIndex), showCustomerShopListDialog = !showCustomerShopListDialog"
                >
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.type }}</td>
                <td>{{ props.item.locationX }}</td>
                <td>{{ props.item.locationY }}</td>
                <td>{{ props.item.customerDTO.name }}</td>
                <td>{{ props.item.cityDTO.name }}</td>
                <td>{{ props.item.townshipDTO.name }}</td>
                <td>{{ props.item.description }}</td>
                <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
                <td>{{ props.item.updatedBy }}</td>
              </template>
            </v-data-table>
            <div class="text-xs-right">
              <v-btn color="primary" @click="setCustomerShop">Ok</v-btn>
            </div>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="500px"
      @keydown.enter="messageDialogBox=!messageDialogBox"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox=!messageDialogBox">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { wayService } from "../../services/way-service";
import { customerShopService } from "../../services/customer-shop-service";
import { commonService } from "../../services/common-service";
import { Way } from "../../models/model";
import { WayFormRules } from "../../helpers/validation-rules";

export default {
  name: "WayDetail",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Way",
        disabled: false,
        to: "ways",
      },
      {
        text: "Way Detail",
        disabled: true,
      },
    ],
    statusFlag: true,
    way: new Way(),
    oldway: new Way(),
    rules: new WayFormRules(),
    responseError: "",
    saveLoading: false,
    selectedCustomerShop: [],
    showCustomerShopListDialog: false,
    headers: [
      { text: "Customer Shop Name", align: "left", value: "name" },
      { text: "Customer Shop Code", value: "code" },
      { text: "Type", value: "type" },
      { text: "LocationX", sortable: false },
      { text: "LocationY", sortable: false },
      { text: "Customer Name", value: "customer.name" },
      { text: "City", value: "city.name" },
      { text: "Township", value: "township.name" },
      { text: "Description", value: "description" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Action", sortable: false },
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0,
    },
    totalRows: 0,
    updatedDate: "",
    createdDate: "",
    queryParams: {
      name: "",
      code: "",
      type: "",
      township: "",
    },
    selectedIndex: 0,
    customerShopType: [
      { label: "----All----", value: "" },
      { label: "WHOLESALE", value: "WHOLESALE" },
      { label: "MODERN_TRADE", value: "MODERN_TRADE" },
      { label: "GENERAL_TRADE", value: "GENERAL_TRADE" },
    ],
    btnDisabled: false,
    showListLoading: false,
    customerShopList: [],
    messageDialogBox: false,
  }),

  watch: {
    pagination: {
      handler() {
        this.getCustomerShopList();
      },
      deep: true,
    },
  },

  created() {
    const id = this.$route.params.id;
    if (id != "new") {
      this.getWayDetail(id);
    }
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getCustomerShopList();
    },

    goBack() {
      this.$router.push("/ways");
    },

    removeCustomerShop(index, wayCustomerShopId) {
      if (wayCustomerShopId) {
        // add deleted wayCustomerShop id
        if (!this.way.deleteWayCustomerShopIds) {
          this.way.deleteWayCustomerShopIds = [];
        }
        this.way.deleteWayCustomerShopIds.push(wayCustomerShopId);
      }
      this.$delete(this.way.wayCustomerShops, index);
    },

    getWayDetail(id) {
      wayService
        .getWayDetail(id)
        .then((res) => {
          this.way = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.way.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.way.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );

          // deep copy
          this.oldway = JSON.parse(JSON.stringify(res.data));

          this.statusFlag = this.way.status == "ACTIVE" ? true : false;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.way.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        wayService
          .saveWay(this.way)
          .then((res) => {
            if (res) {
              this.goBack();
            }
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.way.id) {
        this.way = new Way();
        this.statusFlag = true;
      } else {
        this.way = JSON.parse(JSON.stringify(this.oldway));
        this.statusFlag = this.way.status == "ACTIVE" ? true : false;
      }
    },

    getCustomerShopList() {
      var this_ = this;
      this_.showListLoading = true;
      this_.customerShopList = [];
      return customerShopService
        .getCustomerShops(
          this_.queryParams,
          this_.pagination.page,
          this_.pagination.rowsPerPage
        )
        .then((res) => {
          if (res.data) {
            this_.customerShopList = res.data.customerShopList;
            this_.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this_.showListLoading = false;
        });
    },

    showCustomerShops() {
      // Clean query params
      this.queryParams.name = "";
      this.queryParams.code = "";
      this.queryParams.type = "";
      this.queryParams.township = "";

      this.getCustomerShopList().then(
        (this.showCustomerShopListDialog = !this.showCustomerShopListDialog)
      );
    },
    setWayCustomerShop(customerShop, index) {
      this.way.wayCustomerShops[index].customerShopId = customerShop.id;
      this.way.wayCustomerShops[index].customerShopName = customerShop.name;
      this.way.wayCustomerShops[index].township = customerShop.townshipDTO.name;
    },
    setCustomerShop() {
      if (this.selectedCustomerShop.length) {
        this.selectedCustomerShop.forEach((item) => {
          let wayCustomerShop = {
            id: "",
            customerShopName: "",
            township: "",
            wayId: "",
            customerShopId: "",
          };
          wayCustomerShop.customerShopId = item.id;
          wayCustomerShop.customerShopName = item.name;
          wayCustomerShop.township = item.townshipDTO.name;
          this.way.wayCustomerShops.push(wayCustomerShop);
        });
      }
      this.showCustomerShopListDialog = !this.showCustomerShopListDialog;
    },
    toggleAll() {
      if (this.selectedCustomerShop.length) this.selectedCustomerShop = [];
      else {
        this.selectedCustomerShop = this.customerShopList.slice();
      }
    },
  },
};
</script>

